import React, { useContext } from 'react';
import { AppConfigContext } from '@providers/AppConfigProvider';

export default function Error404() {
  const { pathRoot } = useContext(AppConfigContext);

  return (
    <div className="mx-24 mt-16 max-md:mt-2 max-md:mx-5">
      <h1 className="text-2xl max-md:text-xl font-bold text-center">お探しのページが見つかりませんでした。</h1>
      <p className="mt-16 max-md:14 text-base max-md:text-sm text-center leading-relaxed">
        リノベ不動産をご利用いただきましてありがとうございます。
        <span className="max-md:block">
          お探しのページはすでに削除されたか、アドレスが間違っている可能性がございます。
        </span>
        <span className="max-md:block">ご不便をおかけいたしますが、リノベ不動産トップから引き続きご利用ください。</span>
      </p>
      <div className="group relative mt-14 max-md:16 mx-auto rf-btn-lg">
        <a href="https://renovefudosan.com/">リノベ不動産トップへ</a>
        <img
          src={`${pathRoot}/assets/images/common/ArrowForwardRoundedIcon_black.svg`}
          className="absolute top-[18px] right-4 w-5 hidden group-hover:block"
          alt="arrow"
        />
      </div>
      <p className="mt-16 mb-6 max-md:mt-14 max-md:mb-4 text-center">中古を買ってリノベーションなら、リノベ不動産</p>
    </div>
  );
}
